import {
  faCalendarCheck,
  faMessageDots,
  faVideo,
} from "@fortawesome/duotone-light-svg-icons"
import { capitalizeFirstLetter, FlexBox } from "@joonapp/web-shared"
import { useNavigate, useLocation } from "react-router-dom"

import useCurrentClient from "./hooks/useCurrentClient"
import TabItem from "../../components/tabItem/TabItem"
import { trackAnalyticEvent } from "../../util/analytics"
import { ANALYTIC_EVENTS } from "../../util/analytics"

export enum ClientTab {
  MESSAGES = "messages",
  SESSIONS = "sessions",
  ROUTINES = "routines",
}

const ClientTabNav = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { currentCoachingGroup } = useCurrentClient()

  const activeTab = location.pathname.includes(ClientTab.SESSIONS)
    ? ClientTab.SESSIONS
    : location.pathname.includes(ClientTab.ROUTINES)
    ? ClientTab.ROUTINES
    : ClientTab.MESSAGES

  return (
    <FlexBox direction="row" align="center" wrap={false}>
      <TabItem
        isSelected={activeTab === ClientTab.MESSAGES}
        label={capitalizeFirstLetter(ClientTab.MESSAGES)}
        onClick={() => {
          if (!currentCoachingGroup) return
          navigate(`/${currentCoachingGroup?.id}/${ClientTab.MESSAGES}`)
          trackAnalyticEvent(ANALYTIC_EVENTS.VIEW_CLIENT_TAB, {
            tab: ClientTab.MESSAGES,
          })
        }}
        icon={faMessageDots}
      />
      <TabItem
        isSelected={activeTab === ClientTab.SESSIONS}
        label={capitalizeFirstLetter(ClientTab.SESSIONS)}
        onClick={() => {
          if (!currentCoachingGroup) return
          navigate(`/${currentCoachingGroup?.id}/${ClientTab.SESSIONS}`)
          trackAnalyticEvent(ANALYTIC_EVENTS.VIEW_CLIENT_TAB, {
            tab: ClientTab.SESSIONS,
          })
        }}
        icon={faVideo}
      />
      <TabItem
        isSelected={activeTab === ClientTab.ROUTINES}
        label={"Weekly plan"}
        onClick={() => {
          if (!currentCoachingGroup) return
          navigate(`/${currentCoachingGroup?.id}/${ClientTab.ROUTINES}`)
          trackAnalyticEvent(ANALYTIC_EVENTS.VIEW_CLIENT_TAB, {
            tab: ClientTab.ROUTINES,
          })
        }}
        icon={faCalendarCheck}
      />
    </FlexBox>
  )
}

export default ClientTabNav
